import { render, staticRenderFns } from "./insurance-icon.vue?vue&type=template&id=783e0f7e&"
import script from "./insurance-icon.vue?vue&type=script&lang=js&"
export * from "./insurance-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports